"use client";

import { useEffect } from "react";

export default function GlobalErrorHandler() {
  useEffect(() => {
    // ✅ Handle normal JS runtime errors
    const handleError = (event) => {
      const error = event?.error;

      console.error("🔥 Global JS Error");
      console.error("Message:", event?.message);
      console.error("File:", event?.filename);
      console.error("Line:", event?.lineno);
      console.error("Column:", event?.colno);
      console.error("Stack:", error?.stack);
    };

    // ✅ Handle unhandled promise rejections (async errors)
    const handleRejection = (event) => {
      const error = event?.reason;

      console.error("🔥 Unhandled Promise Rejection");
      console.error("Error:", error);
      console.error("Stack:", error?.stack);
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, []);

  return null;
}